import { Inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  standalone: false,
  name: 'bringozTimeConvert'
})
export class BringozTimeConvertPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService) {}

  transform(timeInSeconds: number, isMillis: boolean = false, isMinutes: boolean = false): string {
    if (!timeInSeconds) {
      return '---';
    }

    if (isMillis) {
      timeInSeconds = timeInSeconds / 1000;
    }

    if (isMinutes) {
      timeInSeconds = timeInSeconds * 60;
    }

    const minute = 60;
    const hour = minute * 60;
    const minutesValue = Math.floor((timeInSeconds / hour) % 1 * minute);
    const minutesText = this.translateService.instant(minutesValue > 1 ? 'mins' : 'min');
    const hoursText = this.translateService.instant((timeInSeconds / hour) >= 2 ? 'hrs' : 'hr');

    const hoursValue = Math.floor(timeInSeconds / hour);
    const formattedHours = hoursValue.toLocaleString(); // 👈 Add commas if needed
    const formattedMinutes = Math.floor(timeInSeconds / minute).toLocaleString(); // 👈 Same here

    return timeInSeconds >= hour
      ? `${formattedHours} ${hoursText}${minutesValue ? ` ${minutesValue.toLocaleString()} ${minutesText}` : ''}`
      : `${formattedMinutes} ${minutesText}`;
  }
}
